// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import buttonSizeVariants from "@guestsupply/MobiusOverrides/Button/buttonSizeVariants";
import CaretLeft from "@guestsupply/XDL/Icons/CaretLeft";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color } from "@guestsupply/XDL/Utilities";
import { mergeWithCss } from "@guestsupply/XDL/Utilities/mergeWithCss";
import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            sizeVariant: "small",
            cssOverrides: {
                formField: css`
                    width: unset;
                    padding-right: 0;
                `,
                formInputWrapper: css`
                    max-width: 75px;
                `,
                inputSelect: css`
                    text-align: center;
                `,
            },
            labelProps: {
                size: 14,
                weight: "normal",
                css: css`
                    letter-spacing: 0;
                    line-height: 21px;
                    justify-content: end;
                    padding: 0 8px 0 0;
                `,
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: CaretLeft,
            nextPage: CaretRight,
            lastPage: "ChevronsRight",
        },

        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
            css: css`
                min-height: 26px;
                border: none;
                ${IconWrapper} {
                    color: ${color("text.main")};
                }
                &:disabled {
                    ${IconWrapper} {
                        color: ${color("text.main", 0.33)};
                    }
                }
                &:hover:not(:disabled) {
                    background: ${color("common.ui1")};
                    border: none;
                    color: ${color("common.ui1")};
                    ${IconWrapper} {
                        color: ${color("common.ui8")};
                    }
                }
            `,
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
                linkList: css`
                    & > ul {
                        display: flex;
                        align-items: center;
                    }
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
